import { render, staticRenderFns } from "./TuiJianFlightCard.vue?vue&type=template&id=3590c755&scoped=true&"
import script from "./TuiJianFlightCard.vue?vue&type=script&lang=js&"
export * from "./TuiJianFlightCard.vue?vue&type=script&lang=js&"
import style0 from "./TuiJianFlightCard.vue?vue&type=style&index=0&id=3590c755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590c755",
  null
  
)

export default component.exports